export default __webpack_public_path__ + "static/media/zain.6761f291.svg";